<template lang="pug">
  b-container
    b-button(variant="light", @click="$router.push({name: 'Products' })")
      .d-flex.align-items-center
        arrow-left-icon.icon-md.mr-2
        span Volver a productos
    b-form-row.align-items-center.my-4
      b-col.mb-2.mb-md-0
        h4.mb-0 Categorías
        //.text-help
          alert-circle-icon.icon-md.mr-1
          span Las categorías te permiten agrupar tus productos. La prioridad indica si se deben mostrar en un orden específico.
      b-col.mb-2.mb-md-0(md="auto")
        b-button(variant="primary", @click="createCategory") Crear categoría
    b-card(no-body)
      b-table.card-table.mb-0(:items="categories", :fields="fields", responsive, @row-clicked="openCategoryModal($event)", hover, show-empty)
        template(v-slot:empty)
          p.mb-0.text-secondary No hay categorías disponibles
        template(v-slot:cell(name)="{ item }")
          .d-flex.align-items-start
            b-img.mr-3(:src="item.image", :blank="!item.image || item.error", @error="item.error = true", width="80", height="80", :rounded="true" blank-color="#f2f2f2" style="object-fit:cover;")
            div
              p.font-weight-bold.mb-1 Nombre de categoría
              b-link.text-secondary(@click="openCategoryModal(item)") {{ item.name }}
              p.mt-1.mb-0.text-primary.font-weight-bold.text-sm(v-if="item.Children && item.Children.length") {{ item.Children.length }} subcategorías
        template(v-slot:cell(description)="{ item }")
          p.font-weight-bold.mb-1 Descripción
          p.mb-0.text-secondary {{ item.description }}
        template(v-slot:cell(status)="{ item }")
          p.font-weight-bold.mb-1 Estatus
          b-form-checkbox(switch, v-model="item.enabled", @change="preUpdate(item)")
        template(v-slot:cell(parent_category_id)="{ item }")
          p.mb-0.text-secondary(v-if="getParentCategoryName(item.parent_category_id) == 'Ninguno'") {{ getParentCategoryName(item.parent_category_id) }}
          p.mb-0(v-else) {{ getParentCategoryName(item.parent_category_id) }}
        template(v-slot:cell(actions)="{ item }")
          edit-3-icon.icon-md.mr-4.hover-primary.pointer(v-b-tooltip.hover="'Editar'", @click.stop="openCategoryModal(item)")
          trash-2-icon.icon-md.hover-danger.pointer(v-b-tooltip.hover="'Eliminar'", @click.stop="confirmDeleteCategory(item)")
    .d-flex.align-items-center
      b-pagination.mb-0(:total-rows="v_paginationItemsCount", :per-page="v_paginationLimit", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'getCategories')", v-if="v_paginationShow")
      b-spinner.ml-3(small, variant="primary", v-if="loading")
    b-modal(v-model="category_modal", :ok-title="isUpdate ? 'Guardar' : 'Crear categoría'", :ok-variant="isUpdate ? 'primary' : 'success'", cancel-title="Cancelar", :title="isUpdate ? 'Actualizar categoría' : 'Crear categoría'", @ok="isUpdate ? updateCategory($event, category) : createCategory($event, category)", :ok-disabled="loading || !category || !category.name", no-close-on-backdrop)
      .d-flex.justify-content-center
        div
          b-img(width="100", height="100", :blank="!category.image || category.error", blank-color="#f2f2f2", rounded, :src="category.image", @error="category.error = true" style="object-fit:scale-down;")
          p.text-center.mt-2
            input(type="file", accept="image/*", ref="upload_image_input", style="display:none;", @change="imagePicked($event)")
            b-link.text-sm(:class="category.image ? 'text-danger' : 'text-primary'", @click="category.image ? category.image = '' : $refs.upload_image_input.click()") {{ category.image ? 'Quitar imagen' : 'Subir imagen' }}
      b-form-group(label="Nombre")
        b-form-input(placeholder="Nombre", v-model="category.name", :state="category.name ? null : false")
      b-form-group(label="Descripción")
        b-form-input(placeholder="Descripción", v-model="category.description")
      b-form-group(label="Prioridad", description="Entre más alto sea el número de prioridad, se mostrará primero.")
        b-form-select(v-model="category.priority")
          option(value="") Sin prioridad
          option(value="0") 0
          option(v-for="n in 100", :value="n") {{ n }}
      //- b-form-group(label="Es subcategoría de:")
      //-   b-form-select(v-model="category.parent_category_id")
      //-     option(value="null") No especificado
      //-     option(v-for="(category, index) in categories.filter(c => c.category_id != category.category_id)", :key="index", :value="category.category_id") {{ category.name }}
      b-form-group(:label="`Subcategorías de \"${category.name || 'esta categoría'}\":`")
        p.mb-2.text-primary.text-sm(v-if="loading_chidren") Actualizando categorías hijas...
        treeselect(:multiple="true", :options="categories.map(c => { return { id: c.category_id, label: c.name } }).filter(c => c.id != category.category_id)", v-model="children_categories")
      b-form-group(label="Estado de categoría")
        .d-flex.align-items-center
          span.mr-3.text-help.text-sm Deshabilitada
          b-form-checkbox.mr-2(switch, v-model="category.enabled")
          span.text-help.text-sm Activa
      b-card.bg-light.text-center.text-sm.mb-0.mt-4(v-if="isUpdate")
        alert-triangle-icon.icon-sm.mr-2
        span Eliminar categoría no se puede deshacer.
        p.mb-0.mt-2
          b-link.text-danger(@click="confirmDeleteCategory(category)") Eliminar categoría
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex'
const categoryController = createNamespacedHelpers('category')
import { toBase64 } from '@/helpers/file-converter'
import { UploadFile } from '@/helpers/upload-file'

export default {
  data () {
    return {
      loading: false,
      category_modal: false,
      category: {
        category_id: null,
        description: '',
        enabled: true,
        image: '',
        name: '',
        parent_category_id: null,
        priority: ''
      },
      fields: [
        {
          key: 'name',
          label: 'Categorías'
        },
        {
          key: 'description',
          label: ''
        },
        {
          key: 'status',
          label: ''
        },
        {
          key: 'actions',
          label: ''
        }
      ],
      file: null,
      children_categories: [],
      loading_chidren: false
    }
  },
  methods: {
    ...mapActions(['category/all', 'category/create', 'category/update', 'category/destroy', 'helpers/upload_file', 'category/parent']),
    getCategories (current) {
      let self = this

      let paginationParams = current == true ? { limit: self.v_paginationLimit, page: self.paginationCurrentPage } : self.paginationParamsObject

      this['category/all']({
        account_id: self.$route.params.account_id,
        params: {
          relationship: "parent",
          ...paginationParams
        },
        callback: res => {
          console.log(res);
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parsePaginationDataFromResponse(res)
          }
        }
      })
    },
    async createCategory () {
      this.showLoadingScreen()
      
      this['category/create']({
        account_id: this.$route.params.account_id,
        callback: res => {
          this.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            console.log(res);
            this.$router.push({name: 'Category', params: {category_id: res.resource.category_id} }).catch(() => {})
          }
        }
      })
    },
    preUpdate(category) {
      console.log(category)
      this.$nextTick(() => {
        this.updateCategory(null, category)
      })
    },
    async updateCategory (modal, category) {
      if (modal && modal.preventDefault) modal.preventDefault()

      let self = this
      self.loading = true

      if (this.file) {
        try {
          this.image_file = await UploadFile.call(this, this.file)
          category.image = this.image_file
        } catch (e) {
          category.image = ''
          self.$message.error('Error subiendo imagen')
        }
      }



      this['category/update']({
        account_id: self.$route.params.account_id,
        ...category,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.updateChidrenCategories(category, () => {
              self.$message.success('Categoría actualizada')
              self.category_modal = false
            })
          }
        }
      })
    },
    confirmDeleteCategory (category) {
      let self = this

      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar la categoría ${category.name}? No se puede deshacer.`, {
          title: 'Eliminar categoría',
          okTitle: 'Eliminar',
          okVariant: 'danger',
          cancelTitle: 'Cancelar'
        })
        .then(value => {
          if (value == true) {
            self.deleteCategory(category)
          }
        })
        .catch(err => {
          // An error occurred
        })
    },
    deleteCategory (category) {
      let self = this

      this['category/destroy']({
        account_id: self.$route.params.account_id,
        ...category,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Categoría eliminada')
            self.category_modal = false
          }
        }
      })
    },
    getParentCategoryName (parent_category_id) {
      let category = this.categories.find(c => c.category_id == parent_category_id)
      if (category) {
        return category.name
      } else {
        return 'Ninguno'
      }
    },
    openCategoryModal (category) {
      // this.file = null
      // this.children_categories = []
      // this.clearObject(this.category, {boolean: true})
      // if (category.category_id) {
      //   this.category = Object.assign(this.category, category)
      //   this.getChildrenCategories(category.category_id)
      // }

      // this.category_modal = true
      this.$router.push({name: 'Category', params: {category_id: category.category_id} }).catch(() => {})
    },
    async imagePicked (event) {
      let file = event.target.files[0]
      this.category.image = URL.createObjectURL(file)
      this.category.error = false
      this.file = file
    },
    async uploadFile (file) {
      let self = this
      return new Promise (async (resolve, reject) => {
        let params = {
          file_name: file.name,
          mime: file.type
        }

        try {
          if (file.name.includes('.'))
            params.file_extension = file.name.split('.').slice(-1)
        } catch (e) {
          console.log(e.message)
        }

        try {
          let fileBase64 = await toBase64(file, true)
          params.file = fileBase64
        } catch (e) {
          console.log(e.message)
          reject(new Error('Error cargando archivo'))
        }

        self['helpers/upload_file']({
          ...params,
          callback: res => {
            if (res.error) {
              reject(new Error(res.error))
            } else {
              resolve(res.resource.url)
            }
          }
        })
      })
    },
    getChildrenCategories (id) {
      let self = this
      this.loading_chidren = true

      this['category/all']({
        account_id: self.$route.params.account_id,
        soft: true,
        params: {
          limit: 1000,
          page: 1,
          parent_category_id: id
        },
        callback: res => {
          self.loading_chidren = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.children_categories = res.resource.map(c => c.category_id)
          }
        }
      })
    },
    updateChidrenCategories (category, callback) {
      let self = this
      this.loading = true

      this['category/parent']({
        account_id: self.$route.params.account_id,
        parent: category.category_id,
        toUpdate: self.children_categories,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.getCategories(true)
          }

          if (callback) callback()
        }
      })
    }
  },
  computed: {
    ...categoryController.mapState({
      categories: state => state.categories
    }),
    isUpdate () {
      return Boolean(this.category.category_id)
    }
  },
  mounted () {
    this.setPaginationLimit(100)
    this.getCategories()
  }
}
</script>

<style lang="scss" scoped>
</style>
